import React from 'react';

import { PackageMonth } from './PackageMonth';

export class PackageTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            month: null,
        };

        this.onInfiniteScrollTrigger = this.onInfiniteScrollTrigger.bind(this);
    }

    onInfiniteScrollTrigger() {
        this.setState({
            page: this.state.page + 1,
        });
    }

    getMonthIndexOfSelectedPackage() {
        if (this.props.selectedPackage == null) {
            return -1;
        }

        for (
            let i = 0, l = this.props.packages.length;
            i < l;
            ++i
        ) {
            for (
                let j = 0, ll = this.props.packages[i].data.length;
                j < ll;
                ++j
            ) {
                if (
                    this.props.packages[i].data[j].ticket.id ===
                    this.props.selectedPackage.ticket.id
                ) {
                    return i;
                }
            }
        }

        return -1;
    }

    renderTickets() {
        let selectedPackageMonthIndex = this.getMonthIndexOfSelectedPackage();
        let items = [];
        let tickets = [];
        for (let i = 0, l = this.props.packages.length; i < l; ++i) {
            tickets = this.props.packages[i].data;

            if (
                selectedPackageMonthIndex > -1 &&
                i > selectedPackageMonthIndex
            ) {
                break;
            }

            items.push(
                <PackageMonth
                    key={i}
                    confirmedTickets={this.props.confirmedTickets}
                    onSelectTicketType={this.props.onSelectTicketType}
                    packages={tickets}
                    month={this.props.packages[i].month}
                    inactive={selectedPackageMonthIndex >
                        -1 &&
                        i <
                        selectedPackageMonthIndex}
                    selectedTicket={this.props.selectedTicket}
                    selectedTicketType={this.props.selectedTicketType}
                    selectedPackage={this.props.selectedPackage}
                    confirmedPackage={this.props.confirmedPackage}
                    addedTickets={this.props.addedTickets}
                    ticketTypes={this.props.ticketTypes}
                    addTicket={this.props.addTicket}
                    removeTicket={this.props.removeTicket}
                    onSelectPackage={this.props.onSelectPackage}
                    onSelectTicket={this.props.onSelectTicket}
                    stepTicketDone={this.props.stepTicketDone}
                    onConfirmTickets={this.props.onConfirmTickets}
                    onDeselectPackage={this.props.onDeselectPackage}
                >
                </PackageMonth>,
            );
        }

        return items;
    }

    render() {
        return (
            <div className="package-list__table">
                {this.renderTickets()}
            </div>
        );
    }
}
